<nav class="agpr-navbar"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
    >
    <div class="agpr-navbar-content">
        @if (logoAltText) {
            <h1 class="u-srOnly">{{ logoAltText | localize }}</h1>
        }

        @if (!logoRouterLink) {
            <div class="agpr-navbar-logoContainer">
                <img [src]="logoUrl" class="agpr-navbar-logo" [alt]="logoAltText | localize" height="50"/>
            </div>
        }
        @if (logoRouterLink) {
            <a class="agpr-navbar-logoContainer" [href]="logoRouterLink">
                <img [src]="logoUrl" class="agpr-navbar-logo" [alt]="(logoAltText | localize) + ' Dashboard'" height="50"/>
            </a>
        }
        <div
            class="agpr-navbar-content-container"
            [ngClass]="{'agpr-navbar-content-container--compressed': compressLeftSide}"
        >
            <h2 class="u-srOnly">{{ 'Core.navigation' | localize }}</h2>
            @if (!compressLeftSide) {
                <ul #leftSide class="agpr-navbar-left" [attr.aria-label]="'Core.navigation.main' | localize">
                    <ng-container *ngTemplateOutlet="menu; context: {menuItems: leftMenuItems, right: false}"></ng-container>
                </ul>
            }

            <div #rightSide class="agpr-navbar-right">
                @if (!compressRightSide) {
                    <ul class="agpr-navbar-right-group" [attr.aria-label]="'Core.navigation.other' | localize">
                        <ng-container *ngTemplateOutlet="menu; context: {menuItems: rightMenuItems, right: true}"></ng-container>
                    </ul>
                }

                @if (quickSearchPermitted) {
                    <form
                    class="agpr-navbar-item quickSearch"
                >
                    <div class="agpr-navbar-itemLabel">
                        <agpr-journodex-quick-search></agpr-journodex-quick-search>
                    </div>
                </form>
                }

                @if (showCompressedNav) {
                    <agpr-button
                        #compressedNav
                        class="agpr-navbar-iconButton"
                        icon="fa-regular fa-duotone fa-bars"
                        [style]="buttonTypes.icon"
                        (click)="openCompressedNav()"
                        [ariaLabel]="compressLeftSide ? 'Core.navigation' : 'Core.navigation.other'"
                    ></agpr-button>
                }
            </div>
        </div>
    </div>
</nav>

<ng-template #menu let-menuItems="menuItems" let-right="right">
    <li *ngFor="let item of menuItems">
        @if (!!item?.routerLink) {
            <a
                [id]="item.id"
                [routerLink]="item.routerLink"
                class="agpr-navbar-item agpr-navbar-item-link"
            >
                <div
                    class="agpr-navbar-itemLabel"
                >
                    {{ item.label | localize }}
                </div>
                @if (item.selected) {
                    <div class="agpr-navbar-activeBar"></div>
                }

            </a>
        }

        @if (!item?.routerLink && item?.items && item?.items?.length > 0 || item?.showUpsell) {
            <div
                class="agpr-navbar-itemContainer"
                [ngClass]="{'agpr-navbar-itemContainer--upsellItem': item.id === 'primaryNavUpsell'}"
                (mouseleave)="hideSubMenu(item)"
                (mouseenter)="showSubMenu(item)"
                (focusout)="onFocusOut($event, item)"
            >
                <button
                    [id]="item.id"
                    class="agpr-navbar-item"
                    [ngClass]="{'agpr-navbar-item--support': item.id !== 'primaryNavSupport'}"
                    (click)="toggleSubMenu(item)"
                    [attr.aria-expanded]="!item.collapsed"
                    [ariaLabel]="'Core.navigation.support.ariaLabel' | localize"
                >
                    @if (item.id !== 'primaryNavSupport') {
                        <div
                            class="agpr-navbar-itemLabel"
                        >
                            {{ item.label | localize }}
                        </div>
                        <span class="agpr-navbar-itemArrow fa-solid fa-chevron-down"></span>
                    }
                    @if (item.id === 'primaryNavSupport') {
                        <span [class]="item.icon" class="agpr-navbar-itemLabel support-icon"></span>
                        <span class="sr-only">{{'Core.navigation.admin.support' | localize}}</span>
                        <span class="agpr-navbar-itemArrow fa-solid fa-chevron-down"></span>
                    }
                    @if (item.selected) {
                        <div class="agpr-navbar-activeBar"></div>
                    }

                </button>
                @if ((item?.items && item?.items?.length > 0 || item?.showUpsell) && !item.collapsed) {
                    <div
                        class="agpr-subMenu-container"
                        @subMenu
                        (@subMenu.start)="item.animating = true;"
                        (@subMenu.done)="item.animating = false;"
                    >
                        <div
                            [id]="item.id + '.subMenu'"
                            class="agpr-subMenu"
                            [ngClass]="{'agpr-subMenu--upsell': item.showUpsell}"
                        >
                            @if (item.showUpsell) {
                                <div
                                    class="agpr-upsell"
                                >
                                    <div class="agpr-upsell-content">
                                        <div class="agpr-upsell-header">
                                            <span class="agpr-upsell-header-icon fa-regular fa-duotone fa-lock"></span>
                                            {{ item.label | localize }}
                                        </div>
                                        <div class="agpr-upsell-message">{{ item.upsellMessage | localize }}</div>
                                        <button
                                            class="agpr-upsell-button"
                                            (click)="openUpsellInfoPanel(item)"
                                        >
                                            {{'Core.navigation.unlock' | localize}}
                                        </button>
                                    </div>
                                </div>
                            } @else {
                                <agpr-scroll-panel>
                                    <ul
                                        [ngSwitch]="item.id"
                                        class="agpr-subMenu-content agpr-subMenu-scrollPanel"
                                        [ngClass]="{
                                            'agpr-subMenu-content--social': item.id === 'primaryNavSocial',
                                            'agpr-subMenu-content--admin': item.id === 'primaryNavAdmin',
                                            'agpr-subMenu-content--account': item.id === 'primaryNavAccounts',
                                            'agpr-subMenu-content--support': item.id === 'primaryNavSupport',
                                            'agpr-subMenu-content--2rows': item.items.length <= 6,
                                            'agpr-subMenu-content--1row': item.items.length <= 3,
                                        }"
                                        [attr.aria-label]="item.label | localize"
                                    >
                                        <ng-container *ngSwitchCase="'primaryNavSupport'">
                                            <ng-container *ngTemplateOutlet="supportMenu; context: {$implicit: item.items}"></ng-container>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'primaryNavAccounts'">
                                            <ng-container *ngTemplateOutlet="accountMenu; context: {$implicit: item.items}"></ng-container>
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            <li
                                                *ngFor="let subItem of item.items"
                                            >
                                                @if (item.id !== 'primaryNavUpsell') {
                                                    <ng-container>
                                                        @if (!subItem?.items) {
                                                            <div
                                                                class="agpr-subMenu-itemContainer"
                                                                [ngClass]="{'agpr-subMenu-itemContainer--disabled': subItem.disabledTooltip || subItem.showUpsell}"
                                                            >
                                                                @if (subItem.disabledTooltip || subItem.showUpsell) {
                                                                    <div class="agpr-subMenu-itemContainer--disabledBanner">
                                                                        <span class="fa-solid fa-lock agpr-subMenu-itemContainer--disabledBannerIcon"></span>
                                                                    </div>
                                                                }
                                                                @if (subItem.routerLink && !subItem.showUpsell) {
                                                                    <a
                                                                        [id]="subItem.id"
                                                                        class="agpr-subMenu-iconLabel subitem"
                                                                        [ngClass]='{"agpr-subMenu-iconLabel--selected": subItem.selected}'
                                                                        [routerLink]="!subItem.disabledTooltip ? subItem.routerLink : undefined"
                                                                        [agprTooltip]="subItem.disabledTooltip | localize"
                                                                    >
                                                                        <ng-container *ngTemplateOutlet="subItemLabel; context: {$implicit: subItem}"></ng-container>
                                                                    </a>
                                                                }
                                                                @if (subItem.routerLink && subItem.showUpsell) {
                                                                    <button
                                                                        [id]="subItem.id"
                                                                        class="agpr-subMenu-iconLabel agpr-subMenu-iconLabel--button subitem"
                                                                        (click)="openSubItemUpsell(subItem, $event)"
                                                                        attr.aria-haspopup="dialog"
                                                                        [attr.aria-label]="subItem.label | localize"
                                                                        [agprTooltip]="subItem.disabledTooltip | localize"
                                                                    >
                                                                        <ng-container *ngTemplateOutlet="subItemLabel; context: {$implicit: subItem}"></ng-container>
                                                                    </button>
                                                                }
                                                                @if (!subItem.routerLink && subItem.type !== types.takeOverPanel && subItem.type !== types.dialog) {
                                                                    <a
                                                                        class="agpr-subMenu-item agpr-subMenu-itemLabel agpr-subMenu-iconLabel-link"
                                                                        [attr.href]="subItem.url"
                                                                    >
                                                                        <span [class]="subItem.icon" class="agpr-subMenu-iconLabel-linkIcon"></span>
                                                                        {{ subItem.label | localize }}
                                                                    </a>
                                                                }
                                                                @if (subItem.type === types.dialog) {
                                                                    <ng-container *ngTemplateOutlet="dialogItem; context: {$implicit: subItem}"></ng-container>
                                                                }
                                                                @if (subItem.type === types.takeOverPanel) {
                                                                    <ng-container *ngTemplateOutlet="takeOverPanel; context: {$implicit: subItem}"></ng-container>
                                                                }

                                                            </div>
                                                        }

                                                    </ng-container>
                                                }

                                            </li>
                                        </ng-container>

                                    </ul>
                                </agpr-scroll-panel>
                            }


                        </div>
                    </div>
                }

            </div>
        }

    </li>
</ng-template>

<ng-template #supportMenu let-items>
    <li *ngFor="let item of items" class="support-item">
        <div class="support-header">
            <span [class]="item.icon" class="support-header-icon"></span>
            {{ item.label | localize }}
        </div>
        <ul class="support-submenu">
            <li *ngFor="let subitem of item.items" class="support-subitem">
                <ng-container [ngSwitch]="subitem.type">
                    <button
                        *ngSwitchCase="types.contactSupport"
                        class="subitem"
                        [id]="subitem.id"
                        (click)="openIntercom()"
                        aria-haspopup="dialog"
                    >
                        {{ subitem.label | localize }}
                    </button>
                    <ng-container *ngSwitchCase="types.dialog">
                        <ng-container *ngTemplateOutlet="dialogItem; context: {$implicit: subitem}"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="types.takeOverPanel">
                        <ng-container *ngTemplateOutlet="takeOverPanel; context: {$implicit: subitem}"></ng-container>
                    </ng-container>
                    <a
                        class="subitem"
                        *ngSwitchDefault
                        [attr.href]="subitem.url"
                        target="{{ subitem.target ? subitem.target : '_blank'}}"
                    >
                        {{ subitem.label | localize }}
                    </a>
                </ng-container>
            </li>
        </ul>
    </li>
</ng-template>

<ng-template #accountMenu let-items>
    <li
        *ngFor="let item of items"
        [ngClass]="{
            'account-list-column': item.type === types.accountList
        }"
    >
        @if (item.type !== types.accountList) {
            <ul
                [ngClass]="{
                    'account-settings-column': item.id === 'primaryNavAccountSettings',
                    'content-management-column': item.id === 'primaryNavManagement'
                }"
            >
                <li *ngFor="let subitem of item.items">
                    @if (!subitem.items && !!subitem.url) {
                        <a
                            [id]="subitem.id"
                            class="account-item subitem"
                            [routerLink]="subitem.routerLink"
                            [attr.href]="subitem.url"
                            target="{{ subitem.target ? subitem.target : '_blank'}}"
                        >
                            <div class="agpr-subMenu-activeBar" [ngClass]='{"agpr-subMenu-activeBar--selected": subitem.selected}'></div>
                            <span [class]="subitem.icon" class="account-item-icon"></span>
                            <div class="account-item-text">
                                {{ subitem.label | localize }}
                            </div>
                        </a>
                    }
                    @if (!subitem.items && !!subitem.routerLink) {
                        <a
                            [id]="subitem.id"
                            class="account-item subitem"
                            [routerLink]="subitem.routerLink"
                        >
                            <div class="agpr-subMenu-activeBar" [ngClass]='{"agpr-subMenu-activeBar--selected": subitem.selected}'></div>
                            <span [class]="subitem.icon" class="account-item-icon"></span>
                            <div class="account-item-text">
                                {{ subitem.label | localize }}
                            </div>
                        </a>
                    }
                    @if ((subitem.id === 'primaryNavContentManagement' || subitem.id === 'primaryNavQuotaUsageDashboards' || subitem.id === 'primaryNavBrandManagement') && subitem?.items?.length > 0) {
                        <ng-container *ngTemplateOutlet="contentManagementPanel; context: {item: subitem}"></ng-container>
                    }
                </li>
            </ul>
        }

        @if (item.type === types.accountList) {
            <ng-container *ngTemplateOutlet="accounts"></ng-container>
        }
    </li>
</ng-template>

<ng-template #accounts>
    <div class="agpr-accounts-workingAs">
        {{ 'Core.navigation.account.workingAs' | localize }}
    </div>

    @if (originalAccounts?.length > 5){
        <div class="agpr-accounts-searchContainer">
            <agpr-text-input
                class="agpr-accounts-search"
                icon="fa-regular fa-duotone fa-magnifying-glass"
                [placeholder]="'Core.navigation.account.search' | localize"
                [bottomMargin]="false"
                [(ngModel)]="searchTerm"
                (ngModelChange)="filterAccounts()"
                type="search"
                [iconDecorative]="true"
            ></agpr-text-input>
        </div>
    }

    @if (userAccounts?.length === 0 ) {
        <agpr-message
            [severity]="messageSeverity.noContent"
        >
            {{ 'Core.navigation.account.notFound' | localize }}
        </agpr-message>
    }
    <agpr-scroll-panel class="agpr-accounts-scrollPanel">
        <ul class="agpr-accounts" [attr.aria-label]="'Core.navigation.accounts' | localize">
            <li
                *ngFor="let account of userAccounts"
            >
                <button
                    [id]="'primaryNavAccount.' + account.id"
                    class="agpr-accounts-account subitem"
                    [class.agpr-accounts-account--selected]="account.id === userState.account.id"
                    [class.agpr-accounts-account--disabled]="!account.active || account.isExpiryDatePast"
                    [disabled]="!account.active || account.isExpiryDatePast"
                    [attr.aria-disabled]="!account.active || account.isExpiryDatePast"
                    (click)="(account.active && !account.isExpiryDatePast && (account.id !== userState.account.id)) ? switchAccount(account) : false"
                >
                    <div class="agpr-accounts-account-activeBar"></div>
                    <span
                        class="agpr-accounts-accountLabel"
                    >
                        {{ account.name }}
                    </span>
                    @if (!account.active || account.isExpiryDatePast) {
                        <span class="agpr-accounts-inactiveLabel">{{ ('Core.navigation.account.inactive' | localize) }}</span>
                    }
                </button>
            </li>
        </ul>
    </agpr-scroll-panel>
</ng-template>

<ng-template #dialogItem let-subItem>
    <button
        [id]="subItem.id"
        class="dialog-item dialog-item-label subitem"
        (click)="coreDialogService.open(subItem.dialogReference); hideAllSubMenus();"
        attr.aria-haspopup="dialog"
        [agprTooltip]="'Core.navigation.contentManagement.openInPanelTooltip' | localize"
        tooltipPosition="top"
        [useTooltipAsAriaLabel]="false"
        [attr.aria-label]="subItem.label | localize"
        [attr.aria-describedby]="subItem.id + '_description'"
    >
        @if (!!subItem.icon) {
            <span [class]="subItem.icon" class="agpr-subMenu-iconLabel-icon"></span>
        }
        {{ subItem.label | localize }}
        <span [id]="subItem.id + '_description'" class="u-srOnly">{{ 'Core.navigation.contentManagement.openInPanelTooltip' | localize }}</span>
        <span class="fa-solid fa-window-restore dialog-item-label-icon"></span>
    </button>
</ng-template>

<ng-template #gridItemContent let-subItem>
    @if (!subItem.disabledTooltip && !subItem.showUpsell) {
        <div class="agpr-subMenu-activeBar" [ngClass]='{"agpr-subMenu-activeBar--selected": subItem.selected}'></div>
    }
    {{ subItem.label | localize }}
</ng-template>

<ng-template #subItemLabel let-subItem>
    <div class="agpr-subMenu-iconLabel-header">
        <div class="agpr-subMenu-activeBar" [ngClass]='{"agpr-subMenu-activeBar--selected": subItem.selected}'></div>
        @if (!!subItem.icon) {
            <span [class]="subItem.icon" class="agpr-subMenu-iconLabel-icon"></span>
        }
        <div class="agpr-subMenu-iconLabel-text">
            {{ subItem.label | localize }}
        </div>
    </div>
    <div class="agpr-subMenu-iconLabel-subLabel">
        {{ subItem.subLabel | localize }}
    </div>
</ng-template>

<ng-template #takeOverPanel let-subItem>
        @let hasSubLabel = subItem?.subLabel;
        <button [id]="subItem.id" class="dialog-item-label subitem" [ngClass]="{
                        'dialog-item': !hasSubLabel,
                        'agpr-subMenu-iconLabel': hasSubLabel
                    }" (click)="openTakeOverPanel(subItem.dialogReference)"
            [agprTooltip]="'Core.navigation.contentManagement.openInPanelTooltip' | localize" tooltipPosition="top"
            [useTooltipAsAriaLabel]="false" aria-haspopup="dialog" [attr.aria-label]="subItem.label | localize"
            [attr.aria-describedby]="subItem.id + '_description'">

            @if (hasSubLabel) {
                <div class="agpr-subMenu-iconLabel-header">
                    <div class="agpr-subMenu-activeBar" [ngClass]='{"agpr-subMenu-activeBar--selected": subItem.selected}'></div>
                    <span [class]="subItem.icon" class="agpr-subMenu-iconLabel-icon"></span>
                    <div class="agpr-subMenu-iconLabel-text">
                        <span class="dialog-item-label-title">{{ subItem.label | localize }}</span>
                        <span [id]="subItem.id + '_description'" class="u-srOnly">{{
                            'Core.navigation.contentManagement.openInPanelTooltip' | localize }}</span>
                        <span class="fa-solid fa-window-restore dialog-item-label-icon"></span>
                    </div>
                </div>
                <div class="agpr-subMenu-iconLabel-subLabel">
                    {{ subItem.subLabel | localize }}
                </div>
            } @else {
                @if (!!subItem.icon) {
                    <span [class]="subItem.icon" class="agpr-subMenu-iconLabel-icon"></span>
                }
                {{ subItem.label | localize }}
                <span [id]="subItem.id + '_description'" class="u-srOnly">{{ 'Core.navigation.contentManagement.openInPanelTooltip'
                    | localize }}</span>
                <span class="fa-solid fa-window-restore dialog-item-label-icon"></span>
            }
        </button>
</ng-template>

<ng-template #contentManagementPanel let-item="item">
    <div class="content-management-panel">
      <div class="content-management-header">
        <span [class]="item.icon" class="content-management-icon"></span>
        <h3>{{ item.label | localize }}</h3>
      </div>
      <ul class="content-management-grid">
        @for (subItem of item.items; track subItem) {
            <li class="content-management-item">
                <div
                    class="agpr-subMenu-itemContainer"
                    [ngClass]="{'agpr-subMenu-itemContainer--disabled': subItem.disabledTooltip || subItem.showUpsell}"
                >
                    @if (subItem.disabledTooltip || subItem.showUpsell) {
                        <div class="agpr-subMenu-itemContainer--disabledBanner">
                            <span class="fa-solid fa-lock agpr-subMenu-itemContainer--disabledBannerIcon"></span>
                        </div>
                    }
                    @switch (subItem.type) {
                        @case (types.dialog) {
                            <ng-container *ngTemplateOutlet="dialogItem; context: {$implicit: subItem}"></ng-container>
                        }
                        @case (types.takeOverPanel) {
                            <ng-container *ngTemplateOutlet="takeOverPanel; context: {$implicit: subItem}"></ng-container>
                        }
                        @default {
                            @if (subItem.showUpsell) {
                                <button
                                    [id]="subItem.id"
                                    class="subitem"
                                    [pTooltip]="subItem.disabledTooltip | localize"
                                    (click)="openSubItemUpsell(subItem, $event)"
                                    attr.aria-haspopup="dialog"
                                >
                                    <ng-container *ngTemplateOutlet="gridItemContent; context: {$implicit: subItem}"></ng-container>
                                </button>
                            } @else if (subItem.routerLink) {
                                <a
                                    [id]="subItem.id"
                                    class="subitem"
                                    [routerLink]="!subItem.disabledTooltip ? subItem.routerLink : undefined"
                                    [pTooltip]="subItem.disabledTooltip | localize"
                                    (click)="$event.stopPropagation()"
                                >
                                    <ng-container *ngTemplateOutlet="gridItemContent; context: {$implicit: subItem}"></ng-container>
                                </a>
                            } @else {
                                <a
                                    class="subitem"
                                    [attr.href]="!subItem.disabledTooltip ? subItem.url : null"
                                    [pTooltip]="subItem.disabledTooltip | localize"
                                    (click)="$event.stopPropagation()"
                                >
                                    <ng-container *ngTemplateOutlet="gridItemContent; context: {$implicit: subItem}"></ng-container>
                                </a>
                            }
                        }
                    }
                </div>
            </li>
        }
      </ul>
    </div>
</ng-template>
